import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import api from "../../../api/axiosInstance";

const HeroSection = () => {
  const navigate = useNavigate();
  const [hero, setHero] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [heroRes, statsRes] = await Promise.all([
          api.get("/api/home"),
          api.get("/api/stats")
        ]);
        setHero(heroRes.data);
        setStats(statsRes.data);
      } catch (err) {
        console.error("Hero load failed", err);
      }
    };

    loadData();
  }, []);

  if (!hero || !stats) return null;

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-12 md:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
              <Icon name="Sparkles" size={16} />
              <span className="font-medium">{hero.badgeText}</span>
            </div>

            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              {hero.heading}
            </h1>

            <p className="text-lg text-muted-foreground mb-8">
              {hero.subHeading}
            </p>

            <div className="flex gap-4 justify-center lg:justify-start">
              <Button
                size="lg"
                onClick={() => navigate("/authentication-portal")}
              >
                {hero.ctaPrimaryText}
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => navigate("/about-platform")}
              >
                {hero.ctaSecondaryText}
              </Button>
            </div>

            <div className="flex gap-6 mt-10 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <Icon name="Star" color="var(--color-accent)" />
                {stats.rating}/5 Rating
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Users" color="var(--color-primary)" />
                {stats.totalStudents.toLocaleString()} Students
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Award" color="var(--color-success)" />
                {stats.successRate}% Success
              </div>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden shadow-xl">
            <img
              src={hero.heroImageUrl}
              alt="Hero"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
